import React, { useEffect } from "react";

export default function FeaturedText({ content }) {
  useEffect(() => {
    if (content.linearGradient) {
      const elements = document.querySelectorAll("#featuredText");
      elements.forEach(element => {
        if (element.className === content.linearGradient) {
          element.style.background = content.linearGradient;
        }
      });
    }
  }, [content]);

  return (
    <div id="featuredText" className={content.linearGradient}>
      {content.image ? (
        <div className="featuredTextImage">
          <div className="image">
            <img src={content.image?.url} alt="featured text" />
          </div>
          <div className="text">
            <div className="header">{content.header}</div>
            <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />
          </div>
        </div>
      ) : (
        <div className="featuredText">
          <div className="header">{content.header}</div>
          <div className="description" dangerouslySetInnerHTML={{ __html: content.description }} />
        </div>
      )}
    </div>
  );
}
